import React from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { CustomButton, CustomInput, Spinner } from 'components';
import { signUp } from 'store/thunks';
import { useAppDispatch, useAppSelector } from 'hooks';
import { PayloadState } from 'interfaces';
import { clearSignUpRequestError } from 'store/slices';
import { loginValidationScheme } from 'validation';
import { ROUTES } from 'constants/routes';

import './RegisterForm.scss';

export const RegisterForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { signUpRequestStatus, signUpRequestError } = useAppSelector(
    (state) => state.auth
  );

  const formik = useFormik({
    initialValues: { email: '', code: '', password: '', confirmPassword: '' },
    onSubmit: (values) => {
      dispatch(clearSignUpRequestError());

      dispatch(signUp(values)).then((data) => {
        if (data.meta.requestStatus === PayloadState.fulfilled) {
          navigate(ROUTES.create_authorized, { replace: true });
        }
      });
    },
    validationSchema: loginValidationScheme,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="login-form-container">
      <div className="login-form-input-box">
        <CustomInput
          id="email"
          name="email"
          label="Email address"
          placeholder="Enter email to get started"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="login-form-validation-error">
            {formik.errors.email}
          </div>
        )}
      </div>
      <div className="login-form-input-box">
        <CustomInput
          id="code"
          name="code"
          type="text"
          label="Registration code"
          placeholder="Your registration code"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="login-form-validation-error">
            {formik.errors.password}
          </div>
        )}
      </div>
      <div className="login-form-input-box">
        <CustomInput
          id="password"
          name="password"
          type="password"
          label="New password"
          // endLabel="Forgot password?"
          placeholder="Choose your password"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="login-form-validation-error">
            {formik.errors.password}
          </div>
        )}
      </div>
      <div className="login-form-input-box">
        <CustomInput
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          label="Confirm password"
          placeholder="Confirm your password"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.confirmPassword && formik.errors.confirmPassword && (
          <div className="login-form-validation-error">
            {formik.errors.confirmPassword}
          </div>
        )}
      </div>
      {signUpRequestStatus !== PayloadState.pending && (
        <CustomButton type="submit" text="Register" width="100%" />
      )}
      {signUpRequestStatus === PayloadState.pending && <Spinner />}
      {signUpRequestError && (
        <div className="login-form-error">{signUpRequestError}</div>
      )}

      <a href={ROUTES.login}>Login?</a>
      <br />
    </form>
  );
};
